import {Integer} from 'platform/foundation';
import styled from 'styled-components';

interface DashboardStretchRegionProps {
  $spacing?: Integer;
}

// eslint-disable-next-line eag/no-css-property -- Muted pre-existing violation
export const DashboardStretchRegion = styled.div<DashboardStretchRegionProps>`
  --dashboard-adaptive-min-height: 0rem;
  --row-gap: ${({$spacing, theme}) => theme.getSize($spacing ?? 0)};

  position: relative;
  flex: 1;
  min-height: var(--dashboard-adaptive-min-height);
  overflow: hidden;
  contain: size;
`;
